import BasemapsIcon from '@apps-common/ui-icons/Basemaps';
import Box from '@mui/material/Box';
import DailyImageryIcon from '@apps-common/ui-icons/DailyImagery';
import MUIDivider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import TaskingIcon from '@apps-common/ui-icons/TaskingDashboard';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';

import Container from '../side-container.jsx';
import FoldersIcon from '@explorer/components/sidebars/folders/icon';
import LocaleModal from '@explorer/components/locale-modal';
import OrdersIcon from '@explorer/components/sidebars/orders/icon';
import SavedSearchesIcon from '@explorer/components/sidebars/saved-searches/icon';
import ToggleButton from '../toggle-button.jsx';
import {DRAWERS, MODALS, TILE_MODE, TOUR_STAGES} from '@explorer/constants';
import {isDev} from '@explorer/config';
import {showLeftDrawer, showModal} from '@explorer/actions/ui';
import {trackEvent} from '@explorer/analytics';
import {withDarkTheme} from '@explorer/styles';

const Divider = props => (
  <MUIDivider variant="middle" sx={{marginX: 1}} {...props} />
);

const LeftNav = props => {
  const {t} = useTranslation();
  const onToggleDrawer = (event, drawer) => {
    // if the drawer is active, clear it.
    props.showLeftDrawer(props.drawer === drawer ? '' : drawer);
  };

  return (
    <Container>
      <Box flexGrow={1} zIndex="inherit">
        <ToggleButton
          value={DRAWERS.SEARCH}
          selected={props.drawer === DRAWERS.SEARCH}
          onClick={onToggleDrawer}
          title={t('navbars.tooltipSearch')}
          data-qe="toggle-scenes"
        >
          <DailyImageryIcon />
        </ToggleButton>
        <ToggleButton
          value={DRAWERS.BASEMAPS}
          selected={props.drawer === DRAWERS.BASEMAPS}
          onClick={onToggleDrawer}
          title={t('navbars.tooltipBasemaps')}
          data-qe="toggle-basemaps"
        >
          <BasemapsIcon />
        </ToggleButton>
        <ToggleButton
          value={DRAWERS.SAVED_SEARCHES}
          selected={props.drawer === DRAWERS.SAVED_SEARCHES}
          onClick={onToggleDrawer}
          title={t('navbars.tooltipSavedSearches')}
          data-qe="toggle-saved-searches"
        >
          <SavedSearchesIcon />
        </ToggleButton>
        <Divider />

        <ToggleButton
          value={DRAWERS.FOLDERS}
          selected={
            props.drawer === DRAWERS.FOLDERS ||
            props.tileMode === TILE_MODE.FOLDERS
          }
          onClick={onToggleDrawer}
          title={t('navbars.tooltipFolders')}
          data-tour={TOUR_STAGES.FOLDERS_SIDEBAR}
        >
          <FoldersIcon />
        </ToggleButton>

        <ToggleButton
          value={DRAWERS.ORDERS}
          selected={props.drawer === DRAWERS.ORDERS}
          onClick={onToggleDrawer}
          title={t('navbars.tooltipPastOrders')}
          data-tour={TOUR_STAGES.ORDERS_SIDEBAR}
        >
          <OrdersIcon />
        </ToggleButton>
        <ToggleButton
          value="taskingDashboard"
          title={t('navbars.tooltipTasking')}
          onClick={() => {
            trackEvent('Clicked Tasking button');
            props.showModal(MODALS.TASKING);
          }}
          data-qe="tasking-dashboard-button"
        >
          <TaskingIcon />
        </ToggleButton>
      </Box>
      <div>
        <Divider />
        {isDev && <LocaleModal />}
        <ToggleButton
          value={DRAWERS.SETTINGS}
          selected={props.drawer === DRAWERS.SETTINGS}
          onClick={onToggleDrawer}
          title={t('navbars.tooltipSettings')}
        >
          <SettingsIcon />
        </ToggleButton>
      </div>
    </Container>
  );
};

LeftNav.propTypes = {
  showLeftDrawer: PropTypes.func,
  drawer: PropTypes.string,
  tileMode: PropTypes.string,
  showModal: PropTypes.func,
};

const mapStateToProps = state => ({
  mode: state.ui.mode,
  drawer: state.ui.drawers.left,
  tileMode: state.tiles.mode,
});

const mapDispatchProps = {
  showLeftDrawer,
  showModal,
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(withDarkTheme(LeftNav));
